<div class="destinations-slider" *ngIf="!selectedGroup">
  <div class="destinations-thumbnail__content">
    <div class="destinations-thumbnail__wrapper">
      <a class="destinations-thumbnail__element"
         (click)="selectGroup(group)"
         *ngFor="let group of destinationBox$ | async">
        <div class="destinations-thumbnail__img"
             [ngStyle]="{'background-image': 'url(' + (group.destinations[0]?.id | imageByCode:'destination' | async | cdnify) + ')'}"
        ></div>
        <div class="destinations-thumbnail__title">{{group.name}}</div>
      </a>
    </div>
  </div>
</div>
<div class="destinations-slider destinations-slider__selected-group" *ngIf="selectedGroup">
  <div class="destinations-thumbnail__cta-back">
    <button class="btn btn--outline btn--xs btn--font-normal" (click)="deselectGroup()"><i class="icon-chevron-left"></i> Torna Indietro</button>
  </div>
  <div class="destinations-thumbnail__content">
    <div class="destinations-thumbnail__wrapper">
      <a class="destinations-thumbnail__element" *ngFor="let destination of selectedGroup.destinations"
         (click)="selectDestination(destination)"
         [ngClass]="{'active': selectedDestinationInner === destination}">
        <div class="destinations-thumbnail__img" [ngStyle]="{'background-image': 'url(' + (destination.id | imageByCode:'destination' | async | cdnify) + ')'}"></div>
        <div class="destinations-thumbnail__title">{{destination.name}}</div>
      </a>
    </div>
  </div>
</div>
